export default __webpack_public_path__ + "static/media/swing_4.bcafbcd2.svg";